import { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext({ isDark: false, toggle: () => {} });

const initial = () => {
  const saved = localStorage.getItem("atas-theme");
  if (saved) return saved === "dark";
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches;
};

export function ThemeProvider({ children }) {
  const [isDark, setDark] = useState(initial);
  useEffect(() => {
    document.documentElement.classList.toggle("dark", isDark);
  }, [isDark]);
  useEffect(() => {
    const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
    const fn = (e) => !localStorage.getItem("atas-theme") && setDark(e.matches);
    mq?.addEventListener?.("change", fn);
    return () => mq?.removeEventListener?.("change", fn);
  }, []);
  const toggle = () => setDark((d) => { localStorage.setItem("atas-theme", d ? "light" : "dark"); return !d; });
  return <ThemeCtx.Provider value={{ isDark, toggle }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
